import { useEffect, useState } from 'react';
import { BaseItem } from './base-item';

export interface UpgradeItemProps {
  id: string;
  image: string[];
  title: string[];
  upgradeLabel?: string[];
  onUpdate?: (state: number, obtained: boolean) => void;
  initialState?: number;
  alwaysObtained?: boolean;
}

export function UpgradeItem(props: UpgradeItemProps) {
  const [state, setState] = useState(props.initialState ?? 0);

  // Sync local state when the parent-provided initialState changes (e.g., a
  // preset/layout import flips an upgrade item's level).
  useEffect(() => {
    setState(props.initialState ?? 0);
  }, [props.initialState]);

  const maxState = props.image.length;
  const index = Math.max(0, state - 1);
  const isObtained = state > 0;

  const handleClick = () => {
    let next = (state + 1) % (maxState + 1);
    if (props.alwaysObtained && next < 1) next = 1;
    setState(next);
    props.onUpdate?.(next, next > 0);
  };

  const handleRightClick = (e: React.MouseEvent) => {
    e.preventDefault();
    let next = Math.max(0, state - 1);
    if (props.alwaysObtained && next === 0) next = 1;
    setState(next);
    props.onUpdate?.(next, next > 0);
  };

  const isMaxLevel = state === maxState;

  return (
    <div className="relative w-8 h-8 flex items-center justify-center">
      <BaseItem
        id={props.id}
        image={props.image[index]}
        title={props.title[index]}
        isObtained={isObtained}
        onClick={handleClick}
        onRightClick={handleRightClick}
        overlay={
          isObtained && props.upgradeLabel?.[index] ? (
            <span
              className={`absolute bottom-0 left-1/2 -translate-x-1/2 text-xs font-bold select-none cursor-pointer
                ${isMaxLevel ? 'text-green-400' : 'text-white'}
                [text-shadow:1px_1px_2px_black,0_0_8px_rgba(0,0,255,0.6)]`}
              onClick={handleClick}
              onContextMenu={handleRightClick}
            >
              {props.upgradeLabel[index]}
            </span>
          ) : undefined
        }
      />
    </div>
  );
}
